import { render, staticRenderFns } from "./App.vue?vue&type=template&id=72b0d0bc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=72b0d0bc&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=72b0d0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0d0bc",
  null
  
)

export default component.exports